import { useContext } from 'react';
import { useHistory } from 'react-router';
import { commonNodeModules, commonModules } from './index';

const useLogOut = () => {
  const { bootbox } = commonNodeModules,
        { UserContext, APICallManager, config, useTranslateText } = commonModules,
        context = useContext(UserContext),
        { translateText } = useTranslateText(),
        history = useHistory();

  const logOutFunction = () => {
    const data = { mode: 'LogOut' },
          obj = {
            url: config.baseUrl + config.loginURL, context: { ...context },
          };
    APICallManager.getCall(obj, data, async (res) => {
      localStorage.clear();
      sessionStorage.clear();
      if (document?.cookie) {
        document.cookie.split(';').forEach(function(c) {
          if (c.indexOf('eidb') > -1 || c.indexOf('eida') > -1 || c.indexOf('mfaCookieID') > -1 ||
        c.indexOf('kidb') > -1 || c.indexOf('kida') > -1) return;
          document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
        });
      }
      if (window.location.href.indexOf('onboarding') !== -1) {
        const { location: { pathname = false } = false } = window;
        history && history.push(pathname === '/' ? '/' : `/${pathname}`);
      }
      else {
        const { Program } = res?.response_data?.[0] || {};
        // Storage and cookies are already cleared above, so an unreadable response must still
        // land on the login page - otherwise the user is left in a half-logged-out session.
        if (Program === 'Login' || !Program) {
          if (!Program) console.error('[ESS] Logout response carried no response_data:', res);
          history.push({
            pathname: `/login`,
          });
          setTimeout(() => {
            location.reload(true);
          }, 10);
        }
      }
      context.isLogin = false;
      return;
    });
  };

  const logOutWithoutPopup = () => {
    logOutFunction();
  };

  const logOut = (popup_message) => {
    bootbox.confirm({
      title: `${translateText(`Message`)}`,
      message: `${translateText(popup_message || `*Your session is no longer valid.  Please login again.`)}`,
      buttons: {
        confirm: {
          label: translateText('Ok'),
          className: 'btn primary_button w-unset pull-right',
        },
        cancel: {
          label: translateText('Cancel'),
          className: `btn primary_button pull-left ${!popup_message && 'd-none'}`,
        },
      },
      callback: (result) => {
        if (result || !popup_message) {
          logOutFunction();
        }
        else { return }
      },
    });
  };

  return {
    logOut,
    logOutWithoutPopup,
  };

};

export default useLogOut;